export default __webpack_public_path__ + "static/media/veronika_s.aab896e3.jpg";